var userAgent;
function setUserAgent(userAgent_) {
  userAgent = userAgent_;
}
export { userAgent, setUserAgent };